import React from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react-lite'
import {Spin} from 'antd'
import {useInjection} from 'dna-react-ioc'

import {disableDatesBeforeOneYear} from '@/stores'
import {RangePickerContainer, RefreshButton, SelectWithTitleContainer} from '@/components'
import {isOctoberRestrictionEnabled} from '@/constants/dateRangePresets'
import {disabledDatesBeforeOctober2025} from '@/utils/moment-utils'

import {TChargebacksFilterStore} from './TChargebacksFilterStore'
import styles from './styles.scss'

export const ChargebacksFilterStoreSymbol = Symbol('ChargebacksFilterStoreSymbol')

export const ChargebacksRangePickerContainerStoreSymbol = Symbol(
    'ChargebacksRangePickerContainerStoreSymbol'
)
export const ChargebacksStatusSelectContainerStoreSymbol = Symbol(
    'ChargebacksStatusSelectContainerStoreSymbol'
)

export const ChargebacksFilter = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<TChargebacksFilterStore>(ChargebacksFilterStoreSymbol)

    const combinedDisabledDate = (date) => {
        if (isOctoberRestrictionEnabled && disabledDatesBeforeOctober2025(date)) {
            return true
        }
        return disableDatesBeforeOneYear(date)
    }

    return (
        <div className={styles.root}>
            <Spin spinning={store.chargebacksTableStore.isLoading} indicator={<></>}>
                <div className={styles.container}>
                    <RefreshButton onClick={store.refresh} />

                    <SelectWithTitleContainer
                        className={styles.select}
                        popupMatchSelectWidth={false}
                        displayValue={t('ChargebacksFilter.status')}
                        injectableIdentifier={ChargebacksStatusSelectContainerStoreSymbol}
                    />

                    <div className={styles.divider}></div>

                    <RangePickerContainer
                        injectableIdentifier={ChargebacksRangePickerContainerStoreSymbol}
                        disabledDate={combinedDisabledDate}
                    />
                </div>
            </Spin>
        </div>
    )
})
